import { IMenu, menu } from './menu';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import { jsonAxios } from 'components/axios';
import { flushSync } from 'react-dom';
import Cookies from 'js-cookie';
import { isLogoutAtom, useGetUser, userAtom } from 'atom/user';
import { useSetAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';

const Nav = () => {
    interface INoti {
        quoteNotification: boolean,
        noticeNotification: boolean,
        warehouseNotification: boolean,
        issueNotification: boolean
    }

    const [isLogout, setIsLogout2] = useState<boolean>(false)
    const user = useGetUser();
    const [noti, setNoti] = useState<INoti>({} as INoti)

    const menuList = useMemo(() => {
        if (isLogout) return [];

        let filtered = menu;

        if (!user.useSolomon) {
            filtered = filtered.filter(arr => arr.titleEn !== "issue");
        }

        if (!user.isMaster) {
            filtered = filtered.filter(arr => arr.titleEn !== "subAccount");
        }

        return filtered;
    }, [user, isLogout]);

    const { pathname } = useLocation();
    const naivate = useNavigate();
    const setIsLogout = useSetAtom(isLogoutAtom);
    const resetUser = useResetAtom(userAtom);

    useEffect(() => {
        getNotification();
    }, [])

    const getNotification = () => {
        jsonAxios.post('user/notification').then(res => {
            if (res.data.code === 200) {
                setNoti(res.data.data)
            }
        })
    }

    const goLink = (url: string, item: IMenu) => {
        if (item.titleEn === 'logout') {
            logout();
        }
        else {
            naivate(url)
        }
    }

    const logout = () => {
        jsonAxios.post('logout').then(() => {
            flushSync(() => {
                setIsLogout(true);
            });
            Cookies.remove("token");
            setIsLogout2(true)
            localStorage.removeItem('token')
            resetUser();
            sessionStorage.removeItem('simple')
            sessionStorage.removeItem('normal')
            window.location.replace('/');
        })
    }

    return (
        <>
            <aside className="mobile:hidden flex flex-col justify-between items-center xl:items-start bg-white 2xl:px-4 pt-10 w-16 2xl:w-[240px] overflow-y-auto text-white shrink-0">
                <div className='flex flex-col gap-3 w-full'>
                    {
                        menuList.map((item, idx) => (
                            <div key={idx}>
                                <div
                                    className={`relative flex items-center justify-center gap-2 text-lg font-semibold w-full py-4 rounded-lg transition-all cursor-pointer hover:text-white  pl-8
                                            ${item.titleEn === 'logout' ? 'text-red hover:bg-red' : 'hover:bg-primary'}
                                            ${(pathname === '/' && item.url === '/')
                                            || pathname.includes(item.titleEn)
                                            ? 'bg-primary text-white'
                                            : 'text-[#9D9EB7]'
                                        }`}
                                    onClick={() => goLink(item.url, item)}
                                >
                                    {
                                        (item.titleEn === 'notice' && noti.noticeNotification)
                                        &&
                                        <div className='top-2 right-2 absolute bg-red rounded-full w-2 h-2'></div>
                                    }
                                    {
                                        (item.titleEn === 'notification' && noti.quoteNotification)
                                        &&
                                        <div className='top-2 right-2 absolute bg-red rounded-full w-2 h-2'></div>
                                    }
                                    {
                                        (item.titleEn === 'issue' && noti.issueNotification)
                                        &&
                                        <div className='top-2 right-2 absolute bg-red rounded-full w-2 h-2'></div>
                                    }
                                    {
                                        (item.titleEn === 'as' && noti.warehouseNotification)
                                        &&
                                        <div className='top-2 right-2 absolute bg-red rounded-full w-2 h-2'></div>
                                    }
                                    <item.icon
                                        className={`fill-current transition-colors ${(pathname === '/' && item.url === '/') || pathname.includes(item.titleEn)
                                            ? 'text-white'
                                            : 'text-[#9D9EB7]'
                                            }group-hover:text-white`}
                                    />
                                    <p className={`hidden 2xl:block flex-1 text-left`}>
                                        {item.title}
                                    </p>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </aside>

            <aside className="hidden mobile:block bottom-0 left-0 z-50 fixed bg-white dark:bg-black border-t-1 w-full h-15">
                <div className='flex justify-center items-center w-full h-full'>
                    {
                        menuList.map((item, idx) => (
                            <div key={idx}>
                                <div
                                    className={`flex items-center justify-center text-lg font-semibold w-full p-3 rounded-lg transition-all cursor-pointer hover:text-white 
                                            ${item.titleEn === 'logout' ? 'text-red hover:bg-red' : 'hover:bg-primary'}
                                            ${(pathname === '/' && item.url === '/')
                                            || pathname.includes(item.titleEn)
                                            ? 'bg-primary text-white'
                                            : 'text-[#9D9EB7]'
                                        }`}
                                    onClick={() => goLink(item.url, item)}
                                >
                                    <item.icon
                                        className={`fill-current transition-colors ${(pathname === '/' && item.url === '/') || pathname.includes(item.titleEn)
                                            ? 'text-white'
                                            : 'text-[#9D9EB7]'
                                            }group-hover:text-white`}
                                    />
                                </div>
                            </div>
                        ))
                    }
                </div>
            </aside>
        </>
    )
}

export default Nav;